import { inject } from '@angular/core';
import { ApiServerService } from '../../core/api';
import {
  OrderBookNumberResponse,
  OrderReportShippingDelayRequest,
  OrderReportShippingDelayResponse,
  OrderRestartRequest,
  OrderRestartResponse,
  OrderValidateFilesRequest,
  OrderValidateFilesResponse
} from './order-api.models';

const baseUrl = 'orders';

export const injectOrderApi = () => {
  const service = inject(ApiServerService);
  return {
    /** Reserves and returns a new order number assigned by the server. */
    bookNumber: (): Promise<OrderBookNumberResponse> => {
      const path = `${baseUrl}/bookNumber`;
      return service.call<OrderBookNumberResponse>(path, {});
    },

    /**
     * Validates that the files of the cart items are available.
     * Returns the indexes of the cart items whose files are not available.
     */
    validateFiles: (data: OrderValidateFilesRequest): Promise<OrderValidateFilesResponse> => {
      const path = `${baseUrl}/validateFiles`;
      return service.call<OrderValidateFilesResponse, OrderValidateFilesRequest>(path, data);
    },

    /** Restarts an order (resets it to its initial state) by id. */
    restart: (request: OrderRestartRequest): Promise<OrderRestartResponse> => {
      const path = `${baseUrl}/restart/${request.orderId}`;
      return service.call<OrderRestartResponse>(path, {});
    },

    /** Notifies the server about a shipping delay for the given order. */
    reportShippingDelay: (request: OrderReportShippingDelayRequest): Promise<OrderReportShippingDelayResponse> => {
      const path = `${baseUrl}/reportShippingDelay/${request.order.id}`;
      return service.call<OrderReportShippingDelayResponse, OrderReportShippingDelayRequest>(path, request);
    }
  };
};
